module.exports = __webpack_public_path__ + "static/img/bcg3.5c14c14a.png";